export default __webpack_public_path__ + "static/media/truck_1_3.8cf1e221.svg";